var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$route.meta && this.$route.meta.layout)?_c(this.$route.meta.layout,{tag:"component"},[_c('router-view')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }